import React, { ReactNode } from 'react';

// Types
import { User } from 'Shared/constants/types';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import UserProfilePopover from 'Dashboard/components/UserProfilePopover/UserProfilePopover';

import './UserDataContainer.scss';

type Props = {
  user: User;
  children: ReactNode;
};

function UserDataContainer({ user, children }: Props) {
  const baseClassName = 'UserDataContainer';
  return (
    <div className={baseClassName}>
      <UserProfilePopover className={`${baseClassName}__details`} userSlug={user.slug}>
        <WpAvatar avatar={user.avatar} size="md" />
        <h5 className={`${baseClassName}__details__label`}>{user.label}</h5>
      </UserProfilePopover>
      {children}
    </div>
  );
}

export default UserDataContainer;
